var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SiteButton',_vm._b({class:_vm.classes,on:{"click":function($event){return _vm.$emit('click')}}},'SiteButton',_vm.$props,false),[_c('SaIcon',{attrs:{"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }